import {Component, computed, input, model} from '@angular/core';

import {IconsComponent} from '../../../../../shared/components/icons/icons.component';

@Component({
  selector: 'app-filters-sidebar-filter',
  standalone: true,
  imports: [IconsComponent],
  templateUrl: './filters-sidebar-filter.component.html',
  styleUrl: './filters-sidebar-filter.component.css'
})
export class FiltersSidebarFilterComponent {
  label = input.required<string>();
  isOpen = model<boolean>(false);

  labelSlug = computed(() => {
    return this.label()
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  });

  headerID = computed(() => `accordion-flush-heading-${this.labelSlug()}`);

  bodyID = computed(() => `accordion-flush-body-${this.labelSlug()}`);

  toggle() {
    this.isOpen.update(open => !open);
  }
}
